import styled from 'styled-components';

export const Main = styled.div`
  max-width: 1300px;
  padding: 16px 60px;
`;

export const SecurityItem = styled.div`
  max-width: 281px;
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AdvancedLink = styled.a`
  font-size: 17px;
  line-height: 1.66;
  letter-spacing: 0.5px;
  color: #1f266b;
  text-decoration: underline;
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/styles.js